import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { GetNumbersAggregatorQuery } from 'src/app/core/api/models';
import { BlackListsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { AppMobilesAnalysisSelectedMode } from 'src/app/core/types/app-mobiles-analysis-selected-mode.type';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { InquiryBlackListListComponent } from "../inquiry-black-list/inquiry-black-list.component";

@Component({
    selector: 'app-numbers-black-lists-form',
    templateUrl: './numbers-black-lists-form.component.html',
    imports: [BaseFormModule, InquiryBlackListListComponent],
    styles: [
        `
      fieldset {
        border: none !important;
      }
    `,
    ]
})
export class NumbersBlackListsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  model: GetNumbersAggregatorQuery = {};
  mobileNumbers: string;
  isShowInquireBlackLists: boolean = false;
  selectedMode: AppMobilesAnalysisSelectedMode;
  file: any = null;
  isVisibleHelpPage: boolean = false;

  constructor(
    protected currentService: BlackListsService,
    public dynamicTabService: DynamicTabService
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getVocabs();
      this.initForm();
      this.pageConfig.showBackBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      numbers: new FormGroup({
        mobileNumbers: new FormControl('', Validators.required),
      }),
    });
  }

  //#region api
  inquireBlackListsApi() {
    this.loading = true;
    this.unSubs();
    this.currentService
      .blackListsUploadFileForInquireBlackLists({
        body: { File: this.file },
      })
      .pipe(this.basePipeOperators())
      .subscribe((response) => {
        if (response.statusCode == 200 && response.isSucceed) {
          this.dynamicTabService.setNewTab('');
          this.dynamicTabService.setNewTab('excelRequest');
          this.dynamicTabService.setActiveTab('excelRequest');
        }
      });
  }
  //#endregion

  onSubmit(): void {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    this.model.numbers = this.mobileNumbers;
  }

  onInquiryMobileAggregators() {
    try {
      this.onSubmit();
      this.isShowInquireBlackLists = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onInquiryBlackList() {
    try {
      if (this.selectedMode == 'uploadFile') this.inquireBlackListsApi();
      else {
        this.onSubmit();
        this.isShowInquireBlackLists = true;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }

  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }
}
